import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { take } from 'rxjs';
import { TwoColumnFormData } from 'src/app/components/shared/form/two-column-form/two-column-form.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { LocationGroup } from 'src/app/core/models/admin/location-admin.model';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { CONSTS } from './group.constants';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
  standalone: false,
})
export class GroupComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;

  readonly CONSTANTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;
  readonly destroy = inject(DestroyRef);

  allGroups!: TwoColumnFormData[];
  assignedGroupData: TwoColumnFormData[] = [];
  copyOfInitialState: TwoColumnFormData[] = [];
  isGroupChanged = false;

  constructor(private locationService: LocationService) {}

  ngOnInit(): void {
    this.copyOfInitialState = this.locationGroupVals;
    this.assignedGroupData = this.locationGroupVals;
    this.locationService
      .getLocationGroups()
      .pipe(take(1))
      .subscribe((data) => {
        this.allGroups = this.mapLocationGroups(
          this.sortGroups(data?.response) || [],
        );
      });

    this.form.valueChanges.subscribe(() => {
      this.assignedGroupData = this.locationGroupVals;
    });
  }

  handleUpdateAssignedValues($event: TwoColumnFormData[]) {
    const assignedValues = $event
      .filter((value) => !!value.selected)
      .map((value) => value.data);
    this.assignedGroupData = this.mapLocationGroups(assignedValues);
    this.locationGroups?.setValue(assignedValues);
    this.locationGroups?.markAllAsTouched();
    this.locationGroups?.markAsDirty();
  }

  get locationGroups() {
    return this.form.get('locationGroups')?.get('assignedGroups');
  }

  get locationGroupVals() {
    return this.mapLocationGroups(this.locationGroups?.value);
  }

  private sortGroups(groups: LocationGroup[]) {
    return groups?.sort((a, b) => a.code?.localeCompare(b.code));
  }

  private mapLocationGroups(groups: LocationGroup[]) {
    return groups?.map((value: LocationGroup) => {
      return { data: value, selected: false };
    });
  }
}
